"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.http = http;
function filterBadStatus(res) {
    if (res.status >= 400) {
        throw new Error(`Bad status on response: ${res.status}`);
    }
    return res;
}
/**
 * Helper to work around missing CORS support in Tendermint (https://github.com/tendermint/tendermint/pull/2800)
 *
 * For some reason, fetch does not complain about missing server-side CORS support.
 */
async function http(method, url, headers, request, timeout) {
    const settings = {
        method: method,
        body: request ? JSON.stringify(request) : undefined,
        headers: {
            "Content-Type": "application/json",
            ...headers,
        },
        signal: timeout ? AbortSignal.timeout(timeout) : undefined,
    };
    return fetch(url, settings)
        .then(filterBadStatus)
        .then((res) => res.json());
}
//# sourceMappingURL=http.js.map